var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7091 19.625L29.988 38.75M20.012 38.75L19.2909 19.625M40.0576 12.805C40.7701 12.9147 41.4801 13.0321 42.1875 13.1571M40.0576 12.805L37.8329 42.3042C37.6451 44.7952 35.6086 46.7188 33.1592 46.7188H16.8408C14.3914 46.7188 12.3549 44.7952 12.1671 42.3042L9.9424 12.805M40.0576 12.805C37.6692 12.4371 35.2531 12.1553 32.8125 11.9629M7.8125 13.1571C8.51995 13.0321 9.22994 12.9147 9.9424 12.805M9.9424 12.805C12.3308 12.4371 14.7469 12.1553 17.1875 11.9629M32.8125 11.9629V10.0161C32.8125 7.51 30.9153 5.41774 28.4596 5.33761C27.3109 5.30013 26.1576 5.28125 25 5.28125C23.8424 5.28125 22.6891 5.30013 21.5404 5.33761C19.0847 5.41774 17.1875 7.51 17.1875 10.0161V11.9629M32.8125 11.9629C30.2345 11.7597 27.6291 11.6562 25 11.6562C22.3709 11.6562 19.7655 11.7597 17.1875 11.9629",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f6466977fc1a51ff6d6e98ee36c95e3b.svg";
export { ForwardRef as ReactComponent };